module.exports = __webpack_public_path__ + "static/media/digital.d2eff258.gif";